/**
 * Ported from sara/app `src/lib/hooks/use-hover-capability.ts` @ e8e8fecb4ec5.
 *
 * Bindery is canonical for this module from 2026-09-04; reconcile app-side
 * drift toward this copy.
 */

import { useMediaQuery } from "./use-media-query";

/**
 * Hook that reports whether the primary pointing device supports hover.
 * Subscribes to `(hover: hover)` through `useMediaQuery` per USES boundary
 * policy §2.2 — previously consumed inline as a one-shot read in
 * `getInitialInputType()`, which silently went stale when hover capability
 * changed mid-session (e.g. plugging in a mouse).
 *
 * SSR default: `true` (assume mouse/desktop as the safe baseline).
 */

const QUERY = "(hover: hover)";

export const useHoverCapability = (): boolean => useMediaQuery(QUERY, true);
